const carouselData = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20scene%20of%20ancient%20Chinese%20fantasy%20drama%20with%20a%20female%20warrior%20in%20flowing%20red%20hanfu%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20mythical%20landscape%2C%20dramatic%20sunset%20sky%20with%20warm%20golden%20and%20coral%20clouds%2C%20cinematic%20wide%20shot%2C%20epic%20scale%2C%20film%20quality%20photography%2C%20heroic%20and%20romantic%20mood&width=1200&height=500&seq=carousel-1-2026&orientation=landscape',
    tag: '古装玄幻',
    title: '长相思 第二季',
    desc: '相柳与小夭跨越千年的爱恨纠葛，大结局催泪上演。全剧热度突破千万，引爆全网追剧热潮。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20stylish%20urban%20romance%20drama%20scene%20with%20a%20couple%20in%20elegant%20fashion%20walking%20through%20a%20cherry%20blossom%20lined%20street%20in%20a%20modern%20city%2C%20soft%20spring%20lighting%2C%20cinematic%20romantic%20composition%2C%20warm%20pink%20and%20cream%20tones%2C%20Korean%20drama%20aesthetic%2C%20high%20production%20value&width=1200&height=500&seq=carousel-2-2026&orientation=landscape',
    tag: '都市爱情',
    title: '你比星光美丽',
    desc: '谭松韵×许凯甜蜜演绎都市爱情故事，播放量突破50亿。甜而不腻，每一帧都让人心动。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Grand%20imperial%20Chinese%20palace%20drama%20scene%20with%20a%20powerful%20male%20protagonist%20in%20elaborate%20traditional%20robes%20in%20a%20magnificent%20throne%20room%2C%20dramatic%20lighting%20from%20candlelight%20and%20lanterns%2C%20cinematic%20composition%2C%20warm%20amber%20and%20gold%20tones%2C%20epic%20historical%20drama%20atmosphere&width=1200&height=500&seq=carousel-3-2026&orientation=landscape',
    tag: '古装权谋',
    title: '庆余年 第二季',
    desc: '张若昀再度封神！豆瓣8.5分权谋神作，庙堂博弈与江湖恩怨交织，口碑全面超越第一季。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20scene%20with%20a%20beautiful%20woman%20in%20traditional%20qipao%20dress%20in%20a%201930s%20Shanghai%20style%20setting%20with%20art%20deco%20elements%2C%20warm%20vintage%20lighting%2C%20cinematic%20portrait%20composition%2C%20nostalgic%20and%20romantic%20mood%2C%20golden%20hour%20window%20light%2C%20rich%20warm%20amber%20and%20cream%20color%20palette&width=1200&height=500&seq=carousel-4-2026&orientation=landscape',
    tag: '都市情感',
    title: '玫瑰的故事',
    desc: '刘亦菲领衔主演，讲述女性在爱情与成长中的蜕变。全40集已上线，豆瓣开分8.0。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20Chinese%20costume%20drama%20scene%20with%20a%20beautiful%20woman%20in%20dark%20hanfu%20holding%20a%20lantern%20in%20a%20bamboo%20forest%20at%20night%2C%20misty%20atmospheric%20lighting%2C%20cinematic%20suspenseful%20composition%2C%20moody%20and%20dramatic%20visuals%2C%20warm%20moonlight%20filtering%20through%20trees%2C%20rich%20dark%20amber%20and%20shadow%20tones&width=1200&height=500&seq=carousel-5-2026&orientation=landscape',
    tag: '古装爱情',
    title: '墨雨云间',
    desc: '权谋与爱情双线并进，反转不断、悬念迭起。播放量突破75亿，成为今夏现象级爆款。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20and%20heartfelt%20slice%20of%20life%20drama%20scene%20with%20a%20multi%20generational%20Asian%20family%20sharing%20a%20meal%20in%20a%20bright%20modern%20kitchen%2C%20natural%20window%20light%20creating%20warm%20cozy%20atmosphere%2C%20cinematic%20composition%2C%20emotional%20and%20authentic%20family%20bonding%20moment%2C%20cream%20and%20terracotta%20warm%20color%20palette&width=1200&height=500&seq=carousel-6-2026&orientation=landscape',
    tag: '治愈力作',
    title: '重启人生',
    desc: '日本现象级神剧，豆瓣9.4分封神。穿越题材的温情治愈之作，被网友称为年度最佳日剧。',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">编辑精选</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">主编团队倾情推荐，为你精选当前最值得追的六部品质好剧</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselData.map((item, i) => (
            <div key={i} className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative w-full aspect-[12/5] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium mb-2 whitespace-nowrap">{item.tag}</span>
                  <h3 className="font-heading text-lg text-white mb-1">{item.title}</h3>
                  <p className="text-white/80 text-xs leading-relaxed hidden sm:block">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}